import { Twitter, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-purple-900 to-pink-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-4">
              <Logo size="md" theme="light" />
            </div>
            <p className="text-purple-200 leading-relaxed">
              A safe space for emotional support, available 24/7 to help you
              navigate life's challenges.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-lg">Platform</h3>
            <ul className="space-y-3 text-purple-200">
              <li>
                <Link
                  to="/how-it-works"
                  className="hover:text-white transition-colors"
                >
                  How it Works
                </Link>
              </li>
              <li>
                <Link
                  to="/become-listener"
                  className="hover:text-white transition-colors"
                >
                  For Listeners
                </Link>
              </li>
              <li>
                <Link
                  to="/safety-privacy"
                  className="hover:text-white transition-colors"
                >
                  Safety & Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="hover:text-white transition-colors"
                >
                  Resources
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-lg">Support</h3>
            <ul className="space-y-3 text-purple-200">
              <li>
                <Link
                  to="/help-center"
                  className="hover:text-white transition-colors"
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  to="/crisis-resources"
                  className="hover:text-white transition-colors"
                >
                  Crisis Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/community-guidelines"
                  className="hover:text-white transition-colors"
                >
                  Community Guidelines
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-white transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-lg">Legal</h3>
            <ul className="space-y-3 text-purple-200">
              <li>
                <Link
                  to="/terms"
                  className="hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="hover:text-white transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/disclaimer"
                  className="hover:text-white transition-colors"
                >
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-purple-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-purple-200 text-sm">
            © 2026 FeelTalk. All rights reserved. Made with care for mental
            wellness.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="#"
              aria-label="Twitter"
              className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            >
              <Twitter className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            >
              <Facebook className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/feeltalk.live/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            >
              <Instagram className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="#"
              aria-label="LinkedIn"
              className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="mt-8 p-5 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20">
          <p className="text-sm text-purple-100 text-center leading-relaxed">
            <strong>Peer Support Notice & Crisis Support:</strong> FeelTalk
            provides peer-to-peer active listening, not professional medical
            therapy or clinical intervention. If you are in crisis or immediate
            danger, please dial <strong>988</strong> (US/CA),{" "}
            <strong>111</strong> (UK), <strong>14416</strong> (IN), or visit our{" "}
            <Link
              to="/crisis-resources"
              className="underline font-bold text-white"
            >
              Crisis Resources
            </Link>{" "}
            page.
          </p>
        </div>
      </div>
    </footer>
  );
}
